import { StudyState } from '@app/types'
import { PeerReviewStatus } from '../types/peerReview.type'
import { ReviewItemType } from '../types/reviewItemType.type'
import { StudyDesignStatus } from '../types/studyDesignStatus.type'
import { Attribute } from './attributes.model'
import { FileMeta } from './file-meta.model'
import { ReviewItem } from './reviewItem.model'
import { FieldSafetyNoticeMetadata } from './reviewItemMetadata/fieldSafetyNoticeMetadata'
import { Search } from './search.model'
import { StudyDesign } from './studyDesign.model'
import { INCLUDED } from '../types/included-screening-criterion.type'

export class FieldSafetyNotice extends ReviewItem {
  metadata: FieldSafetyNoticeMetadata

  constructor({
    complaintDate,
    reviewId,
    search,
    appraisal,
    fullTextScreening,
    id,
    isFavorite,
    maybeParentStudyId,
    oxfordLevelOfEvidence,
    parentStudyId,
    pdfFile,
    peerReviewStatus,
    synthesis,
    titleAndAbstractScreening,
    studyDesign,
    studyDesignStatus,
    metadata,
  }: {
    id: number
    complaintDate?: Date
    reviewId: number
    search: Search
    appraisal?: { [key: string]: string }
    fullTextScreening?: string
    isFavorite?: boolean
    maybeParentStudyId?: number
    oxfordLevelOfEvidence?: string
    parentStudyId?: number
    pdfFile?: FileMeta
    peerReviewStatus?: PeerReviewStatus
    synthesis?: { attributes: Attribute[] }
    titleAndAbstractScreening?: string
    studyDesign?: StudyDesign
    studyDesignStatus?: StudyDesignStatus
    metadata?: FieldSafetyNoticeMetadata
  }) {
    super({
      complaintDate,
      reviewId,
      search,
      appraisal,
      fullTextScreening,
      id,
      isFavorite,
      maybeParentStudyId,
      oxfordLevelOfEvidence,
      parentStudyId,
      pdfFile,
      peerReviewStatus,
      synthesis,
      titleAndAbstractScreening,
      studyDesign,
      studyDesignStatus,
    })
    this.metadata = new FieldSafetyNoticeMetadata(metadata ?? {})
    this.type = ReviewItemType.FieldSafetyNotice
  }

  get state(): StudyState {
    if (this.fullTextScreening === INCLUDED) return StudyState.INCLUDED
    if (
      (this.titleAndAbstractScreening &&
        this.titleAndAbstractScreening != INCLUDED) ||
      (this.fullTextScreening && this.fullTextScreening !== INCLUDED)
    )
      return StudyState.EXCLUDED
    return StudyState.UNSCREENED
  }
}
